import moment, { unitOfTime } from 'moment';

const DEFAULT_STEP = 0;

export default function today(unit: number = DEFAULT_STEP, period: unitOfTime.Base = 'm'): Date {
  const m = moment();
  if (unit) {
    m.add(unit, period);
  }
  return m.startOf('day').toDate();
}
